import { v4 as uuidv4 } from 'uuid'
import { generateDeviceId } from './generateDeviceId'

export const generateXDeviceId = async (userId: number) => {
  try {
    const { userAgent } = navigator

    return await generateDeviceId(userId, userAgent)
  } catch {
    return uuidv4()
  }
}
